import { Badge, Button, Group, Transition } from '@mantine/core';
import ProjectReviewerRoleModal from '@projects/modals/ManageReviewerRoleModal/ManageReviewerRoleModal';

import Project from 'src/entities/project';
import { useState } from 'react';
import Icon from '@ui/components/Icon/Icon';

type ManageReviewerRoleProps = {
	project: Project;
	modalsStackOrder?: number;
	showCustomizePermissions?: boolean;
	disabled?: boolean;
};

const ManageReviewerRole = ( {
	project, modalsStackOrder = 1, showCustomizePermissions, disabled
}: ManageReviewerRoleProps ) => {
	const [ isShowingReviewerRoleModal, setIsShowingReviewerRoleModal ] = useState( false );
	return (
		<>
			<Group spacing={0} align="center">
				<Button
					onClick={() => setIsShowingReviewerRoleModal( true )}
					size="sm"
					variant="white"
					compact
					color="dark.7"
					pl={1}
					disabled={disabled}
					styles={disabled ? { root: { '&[data-disabled]': { opacity: 1, backgroundColor: 'transparent', color: 'inherit', cursor: 'not-allowed', pointerEvents: 'all' } } } : undefined}
				>
					<Group spacing={8}>
						<Icon icon="settings_outlined" size={18} color="dark.7" />
						Manage Reviewer Role
					</Group>
				</Button>
				<Transition mounted={!!showCustomizePermissions} transition="fade" duration={200} timingFunction="ease">
					{styles => (
						<Badge
							p="4px 6px"
							h={22}
							variant="filled"
							style={styles}
							styles={{
								inner: {
									fontFamily: 'Font/family/body',
									fontWeight: 600
								}
							}}
						>
							Customize Permissions
						</Badge>
					)}
				</Transition>
			</Group>
			{isShowingReviewerRoleModal && (
				<ProjectReviewerRoleModal
					project={project}
					onClose={() => setIsShowingReviewerRoleModal( false )}
					stackOrder={modalsStackOrder}
				/>
			)}
		</>
	);
};

export default ManageReviewerRole;
